import { PropertyNames } from "../../../../enums/PropertyNames";
import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaFilter, ISchemaProperty } from "../Schema";
import { NotEmptyString } from "../../../../Validation/Validation";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { hasPermission } from "../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../modules/auth/Permissions/PermissionStrings";
import { EntityNames } from "../../../../enums/EntityNames";
import SidePanelCases from "../../layout/SidePanel/layouts/SidePanelCases";
import SidePanelRanges from "../../layout/SidePanel/layouts/SidePanelRanges";


export const RangesAndCasesSchema: ISchema = {
    displayName: "cases",
    GetSidePanelComponent: (data, onViewPage, entityName) => 
        entityName === EntityNames.cases ? <SidePanelCases data={data} onViewPage={onViewPage} /> : <SidePanelRanges data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'resultType',
            displayName: 'Match Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'code',
            displayName: 'Case Number',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'yearStart',
            displayName: 'Year',
            type: PropertyTypes.year,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'materialType',
            displayName: 'Type',
            type: PropertyTypes.guidList,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'prefix',
            displayName: 'Prefix',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
    ],

    primaryFilter: {
        PropertyName: "Code",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.code,
        placeHolder: "Enter a case number"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "AccountId",
            entityName: EntityNames.accounts,
            displayName: "Account",
            type: FilterTypes.select,
            required: true,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid
        } as ISchemaFilter,
        {
            PropertyName: "Year",
            displayName: "Year",
            type: FilterTypes.year,
            required: true,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.year
        } as ISchemaFilter,
        {
            PropertyName: "Prefix",
            displayName: "Prefix",
            entityName: EntityNames.prefixes,
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.string,
            dependsOn: "AccountId"
        } as ISchemaFilter,
        {
            PropertyName: "CaseMaterialTypeId",
            entityName: "caseMaterialTypes",
            displayName: "Material Type",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Contains,
            propertyType: PropertyTypes.guidList
        } as ISchemaFilter,
        {
            PropertyName: "CaseMaterials.Status",
            entityName: "caseMaterialStatuses",
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int
        } as ISchemaFilter,
        {
            PropertyName: "Notes",
            displayName: "Notes",
            type: FilterTypes.search,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.FreeText,
            propertyType: PropertyTypes.string,
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Inventory_Search_Notes)),
        } as ISchemaFilter,
    ]
}
